import React from "react";
import PropTypes from "prop-types";
import { TextButton } from "components/core/Button";

export const AdditionalNames = ({ handleAddName, children }) => (
	<div className="additional-names">
		<div className="additional-name-input-groups">{children}</div>
		<TextButton
			color="blue"
			flush
			fullWidth={false}
			onClick={handleAddName}
		>
			Add Another Name To This Reservation
		</TextButton>
	</div>
);

AdditionalNames.propTypes = {
	children: PropTypes.node.isRequired,
	handleAddName: PropTypes.func.isRequired
};
